export const glossaryListStandard = {
  list: [
    {
      sys: {
        id: '7gZhTu7Bq82aji6Wk0cvqx',
      },
      slug: 'learn/retirement-glossary/z',
      page: {
        title: 'z',
      },
    },
    {
      sys: {
        id: '120OMazSGDSq4bdjrFXvho',
      },
      slug: 'learn/retirement-glossary/c',
      page: {
        title: 'C',
      },
    },
    {
      sys: {
        id: 'cSYU2pfehqi8cefxgRFOU',
      },
      slug: 'learn/retirement-glossary/kickstart',
      page: {
        title: '(k)ickstart',
      },
    },
    {
      sys: {
        id: '01evcofSiSv7tgcoaQuVCM',
      },
      slug: 'learn/retirement-glossary/401k',
      page: {
        title: '401(k)',
      },
    },
    {
      sys: {
        id: 'kMU7FCLO5kyMg3RiPQfH9',
      },
      slug: 'learn/retirement-glossary/401k2',
      page: {
        title: '401(k)',
      },
    },
  ],
};
